import * as React from "react";
import { connect } from "react-redux";
import { IdSoundState } from "../../constants/IdSoundState";
import { HudOptionButton } from "../generic/hud-option-button/HudOptionButton";
import { actionPlayerSettingsSetSound } from "../info/player-settings/actionPlayerSettingsInfo";
import { IdTooltipAnchor, TooltipText } from "../tooltip";
import { mapHudButtonsSoundDisplayProps } from "./mapHudButtonsSoundDisplayProps";
var _HudToggleSound = function (_a) {
    var isMuted = _a.isMuted, onClick = _a.onClick, soundGroupId = _a.soundGroupId;
    var soundState = isMuted ? IdSoundState.Disabled : IdSoundState.Enabled;
    var infos = mapHudButtonsSoundDisplayProps.get(soundGroupId);
    var soundIcon = infos.icons[soundState];
    var tooltipId = infos.locas[soundState];
    var triggerOnClick = function () {
        var isEnabled = !isMuted;
        onClick(soundGroupId, isEnabled);
    };
    return (React.createElement(TooltipText, { anchor: IdTooltipAnchor.Right, id: tooltipId, className: "hud-options__button-space-bottom" },
        React.createElement(HudOptionButton, { icon: soundIcon, onClick: triggerOnClick })));
};
var mapState = function (state, ownProps) { return ({
    isMuted: state.playerSettingsInfo.sound[ownProps.soundGroupId],
}); };
var mapDispatch = function (dispatch) { return ({
    onClick: function (soundGroupId, isEnabled) {
        return dispatch(actionPlayerSettingsSetSound(soundGroupId, isEnabled));
    },
}); };
export var HudToggleSound = connect(mapState, mapDispatch)(_HudToggleSound);



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/HudToggleSound.tsx
// module id = 2318
// module chunks = 3